import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarOutlook = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Livello_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 512 512",
	style: { enableBackground: "new 0 0 512 512" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: ".outlook-calendar-icon-st0{fill:#0A2767;} .outlook-calendar-icon-st1{fill:#0364B8;} .outlook-calendar-icon-st2{fill:#0078D4;} .outlook-calendar-icon-st3{fill:#28A8EA;} .outlook-calendar-icon-st4{fill:#14447D;} .outlook-calendar-icon-st5{fill:url(#SVGID_1_);} .outlook-calendar-icon-st6{opacity:0.5;fill:#0A2767;enable-background:new ;} .outlook-calendar-icon-st7{fill:#1490DF;} .outlook-calendar-icon-st8{opacity:0.1;enable-background:new ;} .outlook-calendar-icon-st9{opacity:0.05;enable-background:new ;} .outlook-calendar-icon-st10{opacity:0.2;enable-background:new ;} .outlook-calendar-icon-st11{fill:url(#SVGID_2_);} .outlook-calendar-icon-st12{fill:#FFFFFF;} .outlook-calendar-icon-st13{fill:#50D9FF;}"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st0",
			d: "M512,267.91c0.03-4-2.04-7.73-5.45-9.82h-0.06l-0.21-0.12L328.86,152.95c-0.77-0.52-1.56-0.99-2.38-1.42 c-6.85-3.53-14.99-3.53-21.84,0c-0.82,0.43-1.62,0.9-2.38,1.42L124.84,257.96l-0.21,0.12c-5.42,3.37-7.08,10.5-3.71,15.92 c0.99,1.6,2.36,2.93,3.99,3.88L302.32,382.9c0.77,0.51,1.56,0.99,2.38,1.42c6.85,3.53,14.99,3.53,21.84,0 c0.82-0.43,1.61-0.9,2.38-1.42l177.41-105.02C509.88,275.82,512.04,272.01,512,267.91z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st1",
			d: "M145.53,197.79h116.43v106.72H145.53V197.79z M488.19,89.3V40.48c0.28-12.21-9.38-22.33-21.59-22.62H164.47 c-12.21,0.29-21.87,10.42-21.59,22.62V89.3l178.6,47.63L488.19,89.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st2",
			d: "M142.88,89.3h119.07v107.16H142.88V89.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st3",
			d: "M381.02,89.3H261.95v107.16l119.07,107.16h107.16V196.47L381.02,89.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st2",
			d: "M261.95,196.47h119.07v107.16H261.95V196.47z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st1",
			d: "M261.95,303.63h119.07v107.16H261.95V303.63z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st4",
			d: "M145.53,304.51h116.43v97.02H145.53V304.51z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st2",
			d: "M381.02,303.63h107.16v107.16H381.02V303.63z"
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "SVGID_1_",
			gradientUnits: "userSpaceOnUse",
			x1: 315.5344,
			y1: -877.4263,
			x2: 315.5344,
			y2: -651.1933,
			gradientTransform: "matrix(1 0 0 1 0 1145.3334)",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				style: { stopColor: "#35B8F1" }
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				style: { stopColor: "#28A8EA" }
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st5",
			d: "M506.55,277.23l-0.23,0.12l-177.41,99.78c-0.77,0.48-1.56,0.93-2.38,1.33c-3.01,1.43-6.29,2.25-9.62,2.38 l-9.69-5.67c-0.82-0.41-1.61-0.87-2.38-1.37l-179.8-102.61h-0.08l-5.88-3.29V469.9c0.09,13.48,11.09,24.33,24.56,24.24h344.18 c0.2,0,0.38-0.1,0.6-0.1c2.85-0.18,5.65-0.77,8.33-1.74c1.16-0.49,2.28-1.07,3.35-1.74c0.8-0.45,2.17-1.44,2.17-1.44 c6.1-4.51,9.71-11.64,9.74-19.23V267.91C512,271.77,509.91,275.33,506.55,277.23z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st6",
			d: "M502.47,267.11v12.38L316.96,407.22L124.9,271.28c0-0.07-0.05-0.12-0.12-0.12l0,0l-17.62-10.6v-8.93l7.26-0.12 l15.36,8.81l0.36,0.12l1.31,0.83c0,0,180.51,103,180.99,103.23l6.91,4.05c0.6-0.24,1.19-0.48,1.91-0.71 c0.36-0.24,179.2-100.85,179.2-100.85L502.47,267.11z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st7",
			d: "M506.55,277.23l-0.23,0.13l-177.41,99.78c-0.77,0.48-1.56,0.93-2.38,1.33c-6.89,3.37-14.95,3.37-21.84,0 c-0.82-0.4-1.61-0.85-2.38-1.33l-177.41-99.78l-0.21-0.13c-3.43-1.86-5.57-5.43-5.61-9.32V469.9c0.09,13.47,11.08,24.33,24.55,24.24 c0,0,0,0,0,0h343.83c13.47,0.09,24.47-10.77,24.55-24.24c0,0,0,0,0,0V267.91C512,271.77,509.91,275.33,506.55,277.23z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st8",
			d: "M331.49,375.67l-2.66,1.49c-0.77,0.49-1.56,0.94-2.38,1.35c-2.93,1.44-6.11,2.28-9.36,2.48l67.5,79.82 l117.75,28.37c3.23-2.44,5.79-5.64,7.47-9.32L331.49,375.67z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st9",
			d: "M343.52,368.9l-14.68,8.25c-0.77,0.49-1.56,0.94-2.38,1.35c-2.93,1.44-6.11,2.28-9.36,2.48l31.62,87.19 l153.66,20.97c6.05-4.54,9.62-11.67,9.62-19.24v-2.61L343.52,368.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st3",
			d: "M143.96,494.14h343.46c5.29,0.03,10.44-1.64,14.7-4.76L307.2,375.2c-0.82-0.41-1.61-0.87-2.38-1.37 l-179.8-102.61h-0.08l-5.87-3.31v201.3C119.06,482.96,130.2,494.13,143.96,494.14C143.96,494.14,143.96,494.14,143.96,494.14z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st8",
			d: "M285.77,134.94v253.98c-0.02,8.9-5.44,16.91-13.69,20.24c-2.56,1.1-5.31,1.67-8.1,1.67H119.07v-285.8h23.81 v-11.91h121.09C276.01,113.16,285.74,122.91,285.77,134.94z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st10",
			d: "M273.86,146.85v253.98c0.03,2.88-0.58,5.72-1.79,8.33c-3.31,8.15-11.21,13.5-20,13.54h-133V125.02h133 c3.45-0.03,6.86,0.83,9.88,2.5C269.25,131.2,273.86,138.68,273.86,146.85z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st10",
			d: "M273.86,146.85v230.16c-0.06,12.02-9.77,21.77-21.79,21.87h-133V125.02h133c3.45-0.03,6.86,0.83,9.88,2.5 C269.25,131.2,273.86,138.68,273.86,146.85z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st10",
			d: "M261.95,146.85v230.16c-0.01,12.04-9.75,21.81-21.79,21.87H119.07V125.02h121.09 c12.04,0.01,21.8,9.77,21.79,21.81C261.95,146.84,261.95,146.84,261.95,146.85z"
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "SVGID_2_",
			gradientUnits: "userSpaceOnUse",
			x1: 45.5066,
			y1: -1037.3639,
			x2: 216.4467,
			y2: -741.3027,
			gradientTransform: "matrix(1 0 0 1 0 1145.3334)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					style: { stopColor: "#1784D9" }
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					style: { stopColor: "#107AD5" }
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					style: { stopColor: "#0A63C9" }
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st11",
			d: "M21.83,125.02h218.3c12.05,0,21.83,9.77,21.83,21.83v218.3c0,12.05-9.77,21.83-21.83,21.83H21.83 C9.77,386.98,0,377.2,0,365.15v-218.3C0,134.8,9.77,125.02,21.83,125.02z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st12",
			d: "M68.22,216.56c5.38-11.46,14.06-21.05,24.93-27.54c12.04-6.89,25.75-10.33,39.61-9.93 c12.85-0.28,25.53,2.98,36.66,9.42c10.46,6.24,18.89,15.38,24.25,26.31c5.85,12.05,8.76,25.31,8.5,38.7 c0.28,13.99-2.71,27.86-8.75,40.48c-5.49,11.33-14.19,20.79-25,27.23c-11.56,6.64-24.71,9.98-38.03,9.67 c-13.13,0.32-26.09-2.98-37.47-9.53c-10.55-6.25-19.08-15.4-24.58-26.36c-5.88-11.87-8.83-24.99-8.6-38.23 C59.5,242.91,62.4,229.16,68.22,216.56z M94.79,281.22c2.87,7.25,7.73,13.53,14.03,18.12c6.41,4.48,14.09,6.79,21.91,6.6 c8.33,0.33,16.54-2.06,23.39-6.81c6.22-4.58,10.95-10.88,13.62-18.12c2.99-8.09,4.46-16.66,4.35-25.28c0.09-8.7-1.29-17.36-4.1-25.6 c-2.48-7.44-7.06-14-13.19-18.88c-6.68-4.97-14.86-7.5-23.18-7.14c-7.99-0.21-15.84,2.12-22.42,6.66 c-6.4,4.61-11.36,10.95-14.29,18.28c-6.5,16.79-6.54,35.4-0.1,52.21L94.79,281.22z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "outlook-calendar-icon-st13",
			d: "M381.02,89.3h107.16v107.16H381.02V89.3z"
		})
	]
});
export default SvgCalendarOutlook;
